import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'

export default function MirrorPlanDialog({
  isOpen,
  onClose,
  elevationGaragePosition,
  onSelection,
  selectedLotObject,
}) {
  const handleMirror = () => {
    onSelection(selectedLotObject, false, true)
    onClose()
  }

  return (
    <Dialog open={isOpen}>
      <DialogTitle>Mirror this Plan?</DialogTitle>
      <DialogContent>
        {elevationGaragePosition === 'LEFT' ? 'RIGHT' : 'LEFT'} Garage is not
        available for this lot! Selecting will mirror your selected plan, do you
        still want to continue?
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          onClick={handleMirror}
          autoFocus
          color="primary"
          variant="outlined"
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

MirrorPlanDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  elevationGaragePosition: PropTypes.object.isRequired,
  onSelection: PropTypes.func.isRequired,
  selectedLotObject: PropTypes.object.isRequired,
}
MirrorPlanDialog.defaultProps = {}
